export const MainColor = '#5abaae';
export const BackgroundColor = '#EEF8F6';
export const SelectedColor = '#fafbfc';
export const RowHeight = '60';
